import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { BookmarkSimple, Trash, MagnifyingGlass } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function SavedCompanies() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/companies/saved").then((r) => setRows(r.data)).catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    await api.delete(`/companies/saved/${id}`);
    toast.success("Removed");
    setRows((rs) => rs.filter((r) => r.saved_id !== id));
  };

  return (
    <div className="max-w-4xl mx-auto px-8 py-14">
      <h1 className="font-head text-3xl font-bold tracking-tight mb-1">Saved Companies</h1>
      <p className="text-sm text-zinc-500 mb-8">Companies you've bookmarked for future searches.</p>

      {loading ? (
        <p className="text-zinc-400 text-sm">Loading…</p>
      ) : rows.length === 0 ? (
        <div className="text-center py-20 border border-dashed border-zinc-200 rounded-xl">
          <BookmarkSimple size={32} className="mx-auto text-zinc-300 mb-3" />
          <p className="text-zinc-500 text-sm">No saved companies yet.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {rows.map((r) => (
            <div key={r.saved_id} data-testid={`saved-${r.saved_id}`} className="flex items-center gap-4 p-4 bg-white border border-zinc-200 rounded-lg">
              {r.company?.logo && <img src={r.company.logo} alt="" className="w-9 h-9 rounded-md object-contain" onError={(e) => (e.target.style.display = "none")} />}
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-sm">{r.company?.name} · <span className="font-normal text-zinc-600">{r.target_role}</span></p>
                <p className="text-xs text-zinc-400">
                  {r.last_search ? `Last search ${new Date(r.last_search).toLocaleDateString()}` : "Not searched yet"} · {r.contacts_found} contacts
                </p>
              </div>
              <button data-testid={`search-saved-${r.saved_id}`} onClick={() => navigate("/app", { state: { prefill: { company: r.company?.name, role: r.target_role } } })} className="flex items-center gap-1.5 h-9 px-3 rounded-md border border-zinc-200 text-sm hover:bg-zinc-50 transition-colors">
                <MagnifyingGlass size={14} /> Search
              </button>
              <button data-testid={`delete-saved-${r.saved_id}`} onClick={() => del(r.saved_id)} className="text-zinc-400 hover:text-red-600 transition-colors"><Trash size={18} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
